import { appName } from 'src/app-config';
import { Container, FloatingLabel, Form, Modal } from 'react-bootstrap';
import { FC } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeModal: () => void;
};

export const UserPersonalData: FC<propsType> = ({ closeModal }) => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const user = useGetCurrentUser();

    const deletePhoneNumber = () => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se va a eliminar el número de teléfono ${user.phoneNumber} de la aplicación y ya no se podrán recibir en WhatsApp notificaciones, recordatorios ni opciones de autogestión`,
            animation: 3,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.SetPersonalData(user.id, user.name ?? '', user.lastName ?? '', '');
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                window.location.reload();
            }
        }));
    }

    return (
        <Modal className={isDarkMode ? 'text-white' : ''}
            centered
            fullscreen={'md-down'}
            onHide={closeModal}
            show
            size={'lg'}
        >
            <Modal.Header className={isDarkMode ? 'bg-dark' : ''} closeButton>
                <Modal.Title>
                    Datos personales en {appName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-lightdark' : ''}>
                <Container style={{ maxWidth: '500px', padding: isMobile ? '25px 30px 0' : '25px 0' }}>
                    <FloatingLabel className={'mb-3 text-dark'}
                        label={'Dirección de Correo Electrónico'}
                    >
                        <Form.Control type={'email'}
                            className={'form-control'}
                            placeholder={''}
                            value={user.email}
                            disabled
                        />
                    </FloatingLabel>
                    <div className={'row'}>
                        <div className={'col-6'}>
                            <FloatingLabel className={'mb-3 text-dark'}
                                label={'Nombre'}
                            >
                                <Form.Control type={'text'}
                                    className={'form-control'}
                                    placeholder={''}
                                    value={user.name ?? '-'}
                                    disabled
                                />
                            </FloatingLabel>
                        </div>
                        <div className='col-6'>
                            <FloatingLabel className={'mb-3 text-dark'}
                                label={'Apellido'}
                            >
                                <Form.Control type={'text'}
                                    className={'form-control'}
                                    placeholder={''}
                                    value={user.lastName ?? '-'}
                                    disabled
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                    {!!user.phoneNumber &&
                        <>
                        <FloatingLabel className={'my-3 text-dark'}
                            label={'Teléfono celular'}
                        >
                            <Form.Control type={'text'}
                                className={'form-control'}
                                placeholder={''}
                                value={user.phoneNumber}
                                disabled
                            />
                        </FloatingLabel>
                        <div className={'text-center'}>
                            <button className={'btn btn-general-red py-1 mt-1'}
                                style={{ width: '350px' }}
                                onClick={deletePhoneNumber}
                            >
                                Eliminar mi número de teléfono
                            </button>
                        </div>
                        </>
                    }
                    <p className={'text-center small mt-3'}>
                        Nombre, apellido y número de teléfono se guardan con una capa extra de encriptación para evitar robos de datos personales. El número de teléfono solo es conocido internamente por el sistema y no puede ser consultado desde la aplicación, ni siquiera por los administradores.
                    </p>
                </Container>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
                <button className={'btn btn-secondary'}
                    onClick={closeModal}
                >
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
